module.exports = __webpack_public_path__ + "img/Stripe_icon_-_square.3af79c77.svg";